import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { VendaArlaPipe } from './venda-arla.pipe';
import { GerenciarPostosComponent } from './gerenciar-postos/gerenciar-postos.component';

import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTableModule  } from '@angular/material/table';
import { MatCheckboxModule  } from '@angular/material/checkbox';
import { MatFormFieldModule   } from '@angular/material/form-field';
import { MatInputModule   } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatPaginatorModule } from "@angular/material/paginator";
import {MatSelectModule} from '@angular/material/select';
import {MatSortModule} from "@angular/material/sort";
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export const routes: Routes = [
  { path: '', component: GerenciarPostosComponent },


];

@NgModule({
  declarations: [
    GerenciarPostosComponent,
    VendaArlaPipe,
  ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FormsModule,
        ReactiveFormsModule,
        FormsModule,
        MatButtonModule, MatToolbarModule, MatIconModule, MatBadgeModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule, MatInputModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule, MatPaginatorModule,
        MatSelectModule, MatSortModule,
        MatGridListModule
    ],
  exports: [
    GerenciarPostosComponent
  ]
})
export class VendaArlaModule { }
